if (window.location.pathname.includes('/cart')) {
    let loop = setInterval(() => {
      if($(".bss-b2b-discount-code-wrapper").length) {
        clearInterval(loop);
        restyleRF();
      }
    }, 100)
    setTimeout(() => {
      clearInterval(loop);
    }, 15000)
}

function restyleRF() {
  
   
      let input = document.querySelector("#bss-b2b-discount-code-input");
        if(input) {
            input.placeholder = "Renseignez votre code";
        }
}